import React from 'react';
import './styles/secondaryButton.css';

const SecondaryButton = ({ children, onClick, href, type = 'button' }) => {
  if (href) {
    return (
      <a href={href} className="pp-secondary-button pp-secondary-button--link">
        {children}
      </a>
    );
  }

  return (
    <button 
      type={type} 
      className="pp-secondary-button pp-secondary-button--button"
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
